import { Box } from "@mui/material";
import * as React from "react";
import { Translations } from "ui/Scripts/source/models/translations";
import { ISessionState } from "../../../models/session/sessionState";
import { Dialog } from "../../framework/Dialog/Dialog";
import { IIdTitleNode } from "ui/Scripts/source/models/common/idTitleNode";
import { TaskList } from "../TaskList";
import { AppButton } from "ui/Scripts/source/components/framework/Button/AppButton";
import { ITaskPageFilterState } from "../TaskPage/TaskPageUtils";

export interface ITaskTrashBinDialogProp {
    sessionState: ISessionState;
    companyId: string;
    units: IIdTitleNode[];
    onLoadPageData: () => void;
    onClose: () => void;
}

export interface ITaskTrashBinDialogState extends ITaskPageFilterState {
    sortColumn: string;
    sortOrderIsAsc: boolean;
}

export class TaskTrashBinDialog extends React.Component<ITaskTrashBinDialogProp, ITaskTrashBinDialogState> {
    constructor(props: ITaskTrashBinDialogProp) {
        super(props);
        this.state = {
            selectedUnitIds: [],
            selectedStateIds: [],
            selectedPriorityIds: [],
            selectedTaskTypeIds: [],
            selectedHandlerUserCodes: [],
            selectedPersonInChargeUserCodes: [],
            selectedTaskTypeHeaderFields: null,
            selectedTaskTypeFields: null,
            sortColumn: "modifyDate",
            sortOrderIsAsc: false,
        };
    }

    handleFilterSortData = (sortColumn: string, sortOrderIsAsc: boolean) => {
        this.setState({
            sortColumn,
            sortOrderIsAsc,
        });
    };

    render() {
        const props = this.props;
        const state = this.state;
        return (
            <Dialog
                id="taskTrashBinDialog"
                maxWidth="xl"
                maxHeight="100%"
                title={Translations.TrashBin}
                body={
                    <>
                        <TaskList
                            filterName={null}
                            sessionState={props.sessionState}
                            dataId={"0"}
                            canCreateTasks={false}
                            listFilterIsSet={false}
                            units={props.units}
                            selectedUnitIds={state.selectedUnitIds}
                            selectedStateIds={state.selectedStateIds}
                            selectedPriorityIds={state.selectedPriorityIds}
                            selectedTaskTypeIds={state.selectedTaskTypeIds}
                            selectedHandlerUserCodes={state.selectedHandlerUserCodes}
                            selectedPersonInChargeUserCodes={state.selectedPersonInChargeUserCodes}
                            selectedTaskTypeHeaderFields={state.selectedTaskTypeHeaderFields}
                            selectedTaskTypeFields={state.selectedTaskTypeFields}
                            companyId={props.companyId}
                            sortColumn={state.sortColumn}
                            sortOrderIsAsc={state.sortOrderIsAsc}
                            thrashBin={true}
                            onOpenFiltersDialog={null}
                            onSetSortData={this.handleFilterSortData}
                            onLoadPageData={props.onLoadPageData}
                            onOpenTrashBinDialog={null}
                            reportTabs={null}
                        />
                    </>
                }
                actions={
                    <Box display="flex" justifyContent="end" width="100%">
                        <AppButton variant="outlined" onClick={props.onClose}>{Translations.Close}</AppButton>
                    </Box>
                }
                onClose={props.onClose}/>
        );
    }
}